import { Injectable, Inject} from '@angular/core';

export  class PropertyAddressDO {
    public  id:Number = null;
	public  addressLine1:String = null;
	public  addressLine2:String = null;
	public  addressLine3:String = null;
    public  addressLine4:String = null;
    public  cityCd:String = null;
    public  villageCd:String = null;
    public  stateCd:String = null;
    public  countryCd:String = null;
    public  postCode:String = null;
    public  latitude:String = null;
    public  longitude:String = null;
    public  elevation:String = null;
    public  gpsCoord:String = null;
   
}
 